<dialog-draggable-header>
   ECM Parts
</dialog-draggable-header>
<mat-dialog-content class="scroll-dialog-content">
   <div *ngIf="hasLoaded" class="half-height">
      <data-table #partsGrid (lazyLoad)="onLazyLoadParts($event)" [columns]="partColumns" [data]="parts.slice()"
         [pageSize]="partColumnsPageOptions.size" [paging]="true" [filterable]="true" [totalRecords]="totalParts"
         [lazy]="true" (select)="partSelected($event)" (edit)="partRowEdited($event)" [showAllPaging]="false"
         [loading]="loading" [filterColumnDisplay]="false" class="d-inline">
         <ng-container actionStart>
            <button mat-button [disabled]="this.readonly" (keypress.enter)="addPart()" (click)="addPart()">
               Add Part
            </button>
            <button mat-button [disabled]="this.readonly || !this.isPartSelected" (keypress.enter)="deletePart()"
               (click)="deletePart()">
               Delete Part
            </button>
            <button mat-button (keypress.enter)="showReports()" (click)="showReports()">Reports</button>
            <button mat-button [disabled]="this.readonly" (keypress.enter)="supersedePart()" (click)="supersedePart()"
               *ngIf="this.selectedPart && !this.selectedPart?.supersedingPartId">
               Supersede Part
            </button>
            <button mat-button (keypress.enter)="deleteSupersedPart()" (click)="deleteSupersedPart()"
               *ngIf="(this.selectedPart && this.selectedPart?.supersedingPartId  && !this.readonly) || (this.selectedPart && this.selectedPart?.supersedingPartId  && this.resourced)">
               Remove Part Supersession
            </button>
            <mat-form-field class="spacerLeft ">
               <input #searchBar id="search-part-id" type="text" matInput (keydown.enter)="showByPart(searchBar)"
                  [(ngModel)]="searchBarInput" placeholder="Search Part Number" />
               <span *ngIf="searchBarInput" style="margin-left:-20px;">
                  <a (click)="clearSearch()">
                     <i class="fa fa-times" style="color: rgb(149, 149, 153); cursor: pointer;"></i>
                  </a>
               </span>
               <button mat-icon-button matSuffix (click)="showByPart(searchBar)"
                  (keydown.enter)="showByPart(searchBar)">
                  <mat-icon matSuffix>search</mat-icon>
               </button>
            </mat-form-field>

            <button class="part-selection-button" mat-stroked-button [disabled]="showMode === 'all'"
               (keypress.enter)="showAll()" (click)="showAll()">
               Show all Parts
            </button>
            <button class="part-selection-button" mat-stroked-button [disabled]="showMode === 'program'"
               (keypress.enter)="showByProgram()" (click)="showByProgram()">
               Show by Program
            </button>
            <p-dropdown class="program-select-dropdown" [style]="{'width':'175px'}" [options]="programs"
               optionLabel="programNameYear" placeholder="Select a Program" (onChange)="changeProgram($event)"
               [hidden]="showMode !== 'program'">
            </p-dropdown>
            <button class="part-selection-button" mat-stroked-button [disabled]="showMode === 'tool'"
               (keypress.enter)="showByTool()" (click)="showByTool()">
               Show by Tool#: {{this.tool.toolNo}}
            </button>

         </ng-container>
         <ng-container actionEnd>
            <button mat-button (keypress.enter)="close()" (click)="close()">Close</button>
         </ng-container>
      </data-table>
   </div>

   <div class="ecm-parts-container half-height">
      <div class="related-programs">
         <data-table class="ecm-parts-table" [filterColumnDisplay]="false" [columns]="relatedProgramsColumns"
            [data]="relatedPrograms" [paging]="true" [lazy]="true" (lazyLoad)="onLazyLoadPartPrograms($event)"
            [totalRecords]="totalPartPrograms" [pageSize]="relatedProgramsPageOptions.size"
            [showCurrentPageReport]="false">
            <ng-container actionStart>
               <button mat-button [disabled]="this.readonly || !this.isPartSelected"
                  (keypress.enter)="addProgramPartRelation()" (click)="addProgramPartRelation()">Add</button>
               <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
               <span>Related Programs</span>
            </ng-container>
         </data-table>
      </div>
      <div class="related-tools">
         <data-table class="ecm-parts-table" [filterColumnDisplay]="false" [columns]="relatedToolsColumns"
            [data]="relatedTools" [paging]="true" [lazy]="true" (lazyLoad)="onLazyLoadPartTools($event)"
            [totalRecords]="totalToolPrograms" [pageSize]="relatedToolsPageOptions.size"
            [showCurrentPageReport]="false">
            <ng-container actionStart>
               <button mat-button [disabled]="this.readonly || !this.isPartSelected"
                  (keypress.enter)="addToolPartRelation()" (click)="addToolPartRelation()">Add</button>
               <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
               <span>Related Tools</span>
            </ng-container>
         </data-table>
      </div>
      <div class="part-change">
         <data-table #partChangeGrid class="ecm-parts-table" [filterColumnDisplay]="false"
            [columns]="partChangesColumns" [data]="partChanges" (select)="partChangeSelected($event)" [paging]="true"
            [lazy]="true" (lazyLoad)="onLazyLoadPartChanges($event)" [totalRecords]="totalPartChanges"
            [pageSize]="partChangesPageOptions.size">
            <ng-container actionStart>
               <button [disabled]="!this.isPartSelected || this.readonly" mat-button (keypress.enter)="addPartChange()"
                  (click)="addPartChange()">Add Part Change</button>
               <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
               <button [disabled]="!this.isPartChangeSelected || this.readonly" mat-button
                  (keypress.enter)="modifyPartChange()" (click)="modifyPartChange()">Edit Part Change</button>
               <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
               <button [disabled]="!this.isPartChangeSelected || this.readonly" mat-button
                  (keypress.enter)="deletePartChange()" (click)="deletePartChange()">Delete Part
                  Change</button>
            </ng-container>
         </data-table>
      </div>
   </div>
</mat-dialog-content>